function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M154.055 60.7265C161.687 59.5078 164.777 58.5909 172.228 51.4691C179.68 44.3473 187.236 54.7376 198.442 50.566C209.648 46.3944 210.673 41.3437 227.813 56.815C235.714 63.3904 241.999 60.7873 245.871 63.3904C248.453 65.1258 250.942 69.4037 253.337 76.2241H247.093H154.055C146.15 73.4958 142.198 71.2299 142.198 69.4264C142.198 66.7212 146.423 61.9453 154.055 60.7265Z",
  fill: "url(#paint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M72.6478 45.7676C75.5184 45.6523 78.5964 46.3259 81.882 47.7883C84.6159 49.0053 87.1762 50.8415 89.5628 53.297L81.4525 71.5091L64.5374 63.9797L72.6478 45.7676Z",
  fill: "url(#paint1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M152.46 159.57C230.856 159.57 188.201 153.47 203.142 149.63C216.583 146.176 235.959 145.23 235.959 140.58C235.959 130.759 200.759 124.005 152.46 124.005C104.161 124.005 65.0066 131.967 65.0066 141.788C65.0066 151.609 104.161 159.57 152.46 159.57Z",
  fill: "url(#paint2_linear)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.301998,
  d: "M170.94 69H87.0596C85.9221 69 85 69.7731 85 70.7268V134.273C85 135.227 85.9221 136 87.0596 136H170.94C172.078 136 173 135.227 173 134.273V70.7268C173 69.7731 172.078 69 170.94 69Z",
  fill: "url(#paint3_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M110 103C116.627 103 122 97.8513 122 91.5C122 85.1487 116.627 80 110 80C103.373 80 98 85.1487 98 91.5C98 97.8513 103.373 103 110 103Z",
  fill: "url(#paint4_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M112.092 112H98.9076C98.4063 112 98 112.349 98 112.778V115.222C98 115.651 98.4063 116 98.9076 116H112.092C112.594 116 113 115.651 113 115.222V112.778C113 112.349 112.594 112 112.092 112Z",
  fill: "#EBEBF2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M155.16 112H116.84C116.376 112 116 112.349 116 112.778V115.222C116 115.651 116.376 116 116.84 116H155.16C155.624 116 156 115.651 156 115.222V112.778C156 112.349 155.624 112 155.16 112Z",
  fill: "#EBEBF2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.16 121H98.8403C98.3762 121 98 121.349 98 121.778V124.222C98 124.651 98.3762 125 98.8403 125H147.16C147.624 125 148 124.651 148 124.222V121.778C148 121.349 147.624 121 147.16 121Z",
  fill: "#EBEBF2"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M163.713 84.8505C161.759 89.2842 160.567 92.0846 160.136 93.2518C159.936 93.7362 157.352 94.9417 152.385 96.8683C150.719 97.0164 149.767 97.5178 149.528 98.3725C149.392 98.9215 149.453 99.8617 150.301 99.9398C150.866 99.9918 151.671 99.5604 152.717 98.6456C158.266 98.8475 161.567 97.9097 162.618 95.8322C163.67 93.7548 165.271 90.5391 167.422 86.1853L163.971 84.4774L163.713 84.8505Z",
  fill: "url(#paint5_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M181.944 78.2605C181.944 77.4593 185.138 74.7125 186.149 73.6065C186.429 73.5585 181.061 72.5961 177.402 70.3513C174.962 68.8548 174.773 68.364 176.835 68.8791C182.039 69.8606 185.918 70.7296 188.47 71.4861C190.989 72.6382 188.421 76.4089 185.917 80.985C183.413 85.561 181.944 79.0616 181.944 78.2605Z",
  fill: "url(#paint6_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M167.624 131.847C165.979 133.057 164.829 133.661 164.176 133.661C163.196 133.661 162.666 134.704 163.578 135.267C164.489 135.831 167.408 135.019 168.156 135.019C168.904 135.019 170.828 135.341 170.091 132.792C169.599 131.093 169.147 130.369 168.736 130.622L167.624 130.98V131.847Z",
  fill: "#3E3E6E"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M181.294 131.847C182.939 133.057 184.088 133.661 184.742 133.661C185.722 133.661 186.251 134.704 185.34 135.267C184.428 135.831 181.509 135.019 180.762 135.019C180.014 135.019 178.089 135.341 178.827 132.792C179.319 131.093 179.77 130.369 180.182 130.622L181.294 130.98V131.847Z",
  fill: "#3E3E6E"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M167.579 101.872C166.621 109.012 166.341 116.301 166.739 123.738C167.296 131.762 166.712 131.584 167.579 131.584C167.907 131.584 169.24 131.764 169.534 131.235C170.236 129.971 171.372 119.369 170.935 117.237C170.891 116.917 175.305 106.967 175.305 103.097C175.141 102.342 172.566 101.934 167.579 101.872Z",
  fill: "url(#paint7_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M181.203 101.872C182.161 109.012 182.441 116.301 182.043 123.738C181.486 131.762 182.07 131.584 181.203 131.584C180.876 131.584 179.542 131.764 179.248 131.235C178.546 129.971 177.41 119.369 177.848 117.237C177.891 116.917 173.477 106.967 173.477 103.097C173.641 102.342 176.216 101.934 181.203 101.872Z",
  fill: "url(#paint8_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M172.057 69.4016C171.452 72.4594 171.737 74.2575 172.91 74.7959C174.446 75.4438 173.361 76.7811 173.05 76.9455C172.843 77.0552 172.894 77.4268 173.202 78.0605C174.174 78.5802 174.888 78.7871 175.344 78.6813C175.8 78.5756 176.357 78.0552 177.013 77.1203C175.79 76.2299 175.364 75.5155 175.736 74.9772C176.108 74.439 176.672 73.8777 177.43 73.2934C178.165 72.7228 178.137 72.2889 177.345 71.9916C177.536 71.4522 177.607 70.8369 177.558 70.1457L174.979 69.4016L172.355 68.822L172.057 69.4016Z",
  fill: "url(#paint9_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M173.279 76.6954C168.408 76.7978 165.018 79.5324 163.107 84.8991C163.363 84.995 166.921 86.7245 166.921 87.8466C166.921 88.9688 164.949 100.177 165.191 102.516C165.433 104.854 174.878 107.058 184.12 103.976C184.75 103.362 184.157 89.8105 182.533 86.2179C182.449 86.0681 186.513 82.2976 186.228 80.9403C185.944 79.583 183.422 77.1838 182.044 77.1838C180.665 77.1838 177.325 77.4028 176.547 76.6954C176.218 76.3963 176.546 77.6625 174.846 77.6625C174.165 77.6625 173.643 77.3401 173.279 76.6954Z",
  fill: "#5B5BEA"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M173.782 70.0967C176.294 69.372 176.962 70.4855 176.962 70.9565C176.962 71.2705 176.883 71.7911 176.724 72.5182C177.033 72.3789 177.251 72.2731 177.377 72.2008C178.148 71.7594 178.658 70.9765 178.84 70.3667C179.179 69.2273 178.181 66.8102 175.593 67.1705C174.691 66.9976 174.548 65.6522 172.981 66.4798C171.413 67.3074 170.884 66.6712 170.884 67.5197C170.884 68.3682 170.949 70.9833 173.782 70.0967Z",
  fill: "#353564"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M209.219 115.307H210.357C210.759 115.307 211.085 115.633 211.085 116.034V127.797C211.085 128.199 210.759 128.524 210.357 128.524H209.219C208.818 128.524 208.492 128.199 208.492 127.797V116.034C208.492 115.633 208.818 115.307 209.219 115.307Z",
  fill: "#F0F0F3",
  fillOpacity: 0.9
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M207.13 99.5373C204.722 104.476 196.432 119.621 208.048 121.317C219.664 123.013 219.146 112.932 217.109 109.324C215.072 105.717 212.772 103.696 212.772 99.5373C212.772 95.3782 209.538 94.5992 207.13 99.5373Z",
  fill: "url(#paint10_linear)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M144.582 142.192H145.471C145.672 142.192 145.835 142.355 145.835 142.555V149.103C145.835 149.303 145.672 149.466 145.471 149.466H144.582C144.381 149.466 144.219 149.303 144.219 149.103V142.555C144.219 142.355 144.381 142.192 144.582 142.192Z",
  fill: "#FBFBFE"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M143.661 132.78C142.402 135.531 138.07 143.97 144.141 144.915C150.212 145.859 149.941 140.243 148.876 138.233C147.811 136.223 146.609 135.097 146.609 132.78C146.609 130.463 144.919 130.029 143.661 132.78Z",
  fill: "url(#paint11_linear)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 197.767,
  y1: 49.1349,
  x2: 197.767,
  y2: 76.2241,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F6F6F7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FCFCFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 77.8159,
  y1: 48.3262,
  x2: 78.6632,
  y2: 55.2755,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5F5F7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EBEBEF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 112.342,
  y1: 141.355,
  x2: 208.877,
  y2: 159.978,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9F9FC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#EDEDF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 129,
  y1: 69,
  x2: 129,
  y2: 135.054,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCDCE4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DEDEE6",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 115.734,
  y1: 100.961,
  x2: 106.372,
  y2: 79.6976,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F4F4F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E2E2E9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 151.749,
  y1: 97.227,
  x2: 163.794,
  y2: 86.0055,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD2C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFB8A3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 182.461,
  y1: 70.0401,
  x2: 185.21,
  y2: 79.1716,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD2C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFB8A3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 170.716,
  y1: 129.433,
  x2: 176.402,
  y2: 106.858,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7878C3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5C5CBB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 178.051,
  y1: 130.195,
  x2: 175.711,
  y2: 103.209,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7878C3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5C5CBB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 173.058,
  y1: 70.4172,
  x2: 177.877,
  y2: 75.8514,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFD2C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFB8A3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 210.131,
  y1: 96.1196,
  x2: 210.131,
  y2: 121.508,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EBEBEE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FCFCFD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 145.229,
  y1: 130.876,
  x2: 145.229,
  y2: 145.021,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EBEBEE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FCFCFD"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 288,
  height: 216,
  fill: "white"
})));

var SvgNoTeam = function SvgNoTeam(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 216,
    viewBox: "0 0 288 216",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoTeam, _extends({
    svgRef: ref
  }, props));
});
export default "https://sf16-website.neutral.ttwstatic.com/obj/tiktok_web_static/bytecom/api_gateway_web_i18n/static/media/noTeam.58bb4d09.svg";
export { ForwardRef as ReactComponent };